import React from 'react';
import PropTypes from 'prop-types';
import SidebarNavigationItem from "./SidebarNavigationItem";

const SidebarNavigationGroup = ({title, items, onRouteChange}) => {
    return (
        <>
            <ul className="p-nav-side__list">
                <li className="p-nav-side__title">{title}</li>
                {items.map(item => (
                    <SidebarNavigationItem
                        key={item.route}
                        title={item.title}
                        route={item.route}
                        onRouteChange={onRouteChange}/>)
                )}
            </ul>
            <hr className="p-nav-side__split"/>
        </>
    )
};

SidebarNavigationGroup.propTypes = {
    title: PropTypes.string,
    items: PropTypes.array
};
SidebarNavigationGroup.defaultProps = {
    items: []
};

export default SidebarNavigationGroup;
